import countTo from 'vue-count-to';
export default {
  name: 'cardList',
  components: {
    countTo
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    sendTitle(title, key) {
      this.$emit('sendTitle', title, key);
    }
  }
};